import React from "react";
import BaseTextInput from "./BaseTextInput";
import TextInputProps from "./TextInputProps";

export default function InPlaceTextInput(props: TextInputProps) {
  return (
    <div className="inline-block">
      <BaseTextInput {...props} className={props.className}/>
    </div>
  );
}